const pgcetmbaAnalyticalReasoning = [
  {
    id: 21,
    question: "Who is regarded as the architect of India's economic liberalization reforms of 1991?",
    options: ["A. Rajiv Gandhi", "B. Manmohan Singh", "C. P.V. Narasimha Rao", "D. Both (2) and (3)"],
    answer: "D"
  },
  {
    id: 22,
    question: "The headquarters of the International Monetary Fund (IMF) is located in:",
    options: ["A. Geneva", "B. Washington D.C.", "C. New York", "D. Brussels"],
    answer: "B"
  },
  {
    id: 23,
    question: "Which Article of the Indian Constitution deals with the Right to Constitutional Remedies?",
    options: ["A. Article 19", "B. Article 21", "C. Article 32", "D. Article 44"],
    answer: "C"
  },
  {
    id: 24,
    question: "The 'White Revolution' in India is associated with:",
    options: ["A. M.S. Swaminathan", "B. Verghese Kurien", "C. Norman Borlaug", "D. Sam Pitroda"],
    answer: "B"
  },
  {
    id: 25,
    question: "'Scalar chain' in management theory was propounded by:",
    options: ["A. F.W. Taylor", "B. Henri Fayol", "C. Elton Mayo", "D. Peter Drucker"],
    answer: "B"
  },
  {
    id: 26,
    question: "The concept of 'Management by Objectives' (MBO) was introduced by:",
    options: ["A. Henri Fayol", "B. Peter F. Drucker", "C. Elton Mayo", "D. F.W. Taylor"],
    answer: "B"
  },
  {
    id: 27,
    question: "Which of the following best describes a 'Liquidity Trap' in economics?",
    options: [
      "A. High interest rates reducing investment",
      "B. Monetary policy becoming ineffective as interest rates near zero",
      "C. Excess liquidity causing asset bubbles",
      "D. Consumer spending declining due to inflation"
    ],
    answer: "B"
  },
  {
    id: 28,
    question: "The 'Minimum Support Price' (MSP) in India refers to:",
    options: [
      "A. Export subsidy for farm produce",
      "B. Guaranteed price support to farmers for their produce",
      "C. Tax exemption on agricultural equipment",
      "D. Interest subsidy on farm loans"
    ],
    answer: "B"
  },
  {
    id: 29,
    question: "Which organization administers the 'Padma Awards' in India?",
    options: ["A. Ministry of Culture", "B. Ministry of Home Affairs", "C. Sahitya Akademi", "D. Ministry of External Affairs"],
    answer: "B"
  },
  {
    id: 30,
    question: "The 'Kyoto Protocol' primarily aims to:",
    options: [
      "A. Promote free trade between nations",
      "B. Reduce greenhouse gas emissions",
      "C. Regulate nuclear disarmament",
      "D. Protect intellectual property rights"
    ],
    answer: "B"
  },
  {
    id: 31,
    question: "Which Indian state has 'Kudumbashree', a women's empowerment and poverty eradication programme?",
    options: ["A. Karnataka", "B. Tamil Nadu", "C. Kerala", "D. Andhra Pradesh"],
    answer: "C"
  },
  {
    id: 32,
    question: "The Reserve Bank of India was established in the year:",
    options: ["A. 1935", "B. 1947", "C. 1949", "D. 1955"],
    answer: "A"
  },
  {
    id: 33,
    question: "Who among the following is credited with coining the phrase 'Unity in Diversity' for India?",
    options: ["A. Mahatma Gandhi", "B. Jawaharlal Nehru", "C. Rabindranath Tagore", "D. Sardar Patel"],
    answer: "B"
  },
  {
    id: 34,
    question: "Which Indian classical dance form originated in the state of Odisha?",
    options: ["A. Kuchipudi", "B. Odissi", "C. Manipuri", "D. Sattriya"],
    answer: "B"
  },
  {
    id: 35,
    question: "The 'Blue Revolution' in India refers to the development of:",
    options: ["A. Dairy industry", "B. Fisheries and aquaculture", "C. Petroleum industry", "D. Renewable energy"],
    answer: "B"
  },
  {
    id: 36,
    question: "The World Anti-Doping Agency (WADA) is headquartered in:",
    options: ["A. Montreal, Canada", "B. Geneva, Switzerland", "C. New York, USA", "D. Lausanne, Switzerland"],
    answer: "A"
  },
  {
    id: 37,
    question: "'Angel investors' are best described as those who:",
    options: [
      "A. Only invest in publicly listed companies",
      "B. Provide funding at an early stage of a startup",
      "C. Regulate stock market transactions",
      "D. Provide loans to government projects"
    ],
    answer: "B"
  },
  {
    id: 38,
    question: "The 'Desert National Park', a protected wildlife sanctuary, is located in which two districts of Rajasthan?",
    options: ["A. Jodhpur and Bikaner", "B. Jaisalmer and Barmer", "C. Jaisalmer and Jodhpur", "D. Barmer and Bikaner"],
    answer: "B"
  },
  {
    id: 39,
    question: "The Nobel Peace Prize is awarded by a committee based in:",
    options: ["A. Stockholm, Sweden", "B. Oslo, Norway", "C. Geneva, Switzerland", "D. The Hague, Netherlands"],
    answer: "B"
  },
  {
    id: 40,
    question: "Which of the following best defines an 'IPO' in the context of business finance?",
    options: [
      "A. A loan given by a bank to a startup",
      "B. The process by which a private company offers shares to the public for the first time",
      "C. A merger between two companies",
      "D. A government subsidy scheme for exporters"
    ],
    answer: "B"
  }

];
 
export default pgcetmbaAnalyticalReasoning;